import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { CommonService } from 'src/app/service/common.service';
import { MqttService } from 'src/app/service/mqtt.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  lat: number = 13.746571;
  lon: number = 100.517057;

  constructor(public cm:CommonService,public mqtt:MqttService) { }

  ngOnInit() {
    this.setupPage();
    this.setAttr();
  }

  ngOnDestroy(){
    console.log('destroy');
    this.mqtt.disconnect();
  }

  database;
  setupPage(){
    console.log('get database');
    const api = '/v1.0/devices';
    this.cm.getHtpp(api,'').then((data:any)=>{
      console.log(data);
      this.database = data.data;
      this.showDevice = data.data;
    }).then(()=>{
      const api2 = '/v1.0/mqtt/user_token';
      this.cm.postHtpp(api2,'').then((data:any)=>{
        console.log(data);
        this.mqtt.connectMqtt(data.mqtt_username,data.mqtt_password,this.database);
        var config = this.cm.getConfig();
        config.mqtt_username = data.mqtt_username;
        config.mqtt_password = data.mqtt_password;
        sessionStorage.setItem('config',JSON.stringify(config));
        this.setMap();
      });
    });
  }

  setAttr(){

  }

  @ViewChild("input_search_text") inputEl: ElementRef;
  showDevice;
  search(text){
    this.showDevice = [];
    for(var i = 0;i<this.database.length;i++){
      var sameData = 0;
      for (var key in this.database[i]) {
        if(String(this.database[i][key]).match(text)){
            this.showDevice.push(this.database[i]);
            sameData = 1;
        }

        for (var key in this.database[i].attribute) {
          if(String(this.database[i].attribute[key]).match(text) && sameData == 0){
              this.showDevice.push(this.database[i]);
          }
        } 
        sameData = 0;
      } 
      // show zoom
      // var datamap = [];
      // for(var i = 0;i < this.showDevice.length;i++){
      //   if(this.showDevice[i].attribute){
      //     datamap.push(this.showDevice[i]);
      //   }
      // }
      // this.setZoomMap(datamap[0]);
      
    }
    this.setZoomMap(this.showDevice);
    this.showDevice = this.cm.removeDuplicates(this.showDevice,'id');
  }

  clickSetting(uuid){
    console.log(uuid);
    
    this.cm.goto('setting/'+uuid);
  }

  mapDatabase = [];
  setMap(){
    this.mapDatabase = [];
    for(var i = 0;i < this.database.length;i++){
      if(this.database[i].attribute){
        if(this.database[i].attribute.lon){
          this.mapDatabase.push(this.database[i]);
        }
      }
    }
    console.log( this.mapDatabase);
  }

  zoom = 7;
  showZoom = {
    lat:0,
    lon:0
  };
  setZoomMap(data){
    var show = [];
    for(var i = 0;i < data.length;i++){
      if(data[i].attribute){
        show.push(data[i]);
      }
    }
    if(show.length > 0){
      if(show[0].attribute.lat && this.showZoom.lat != show[0].attribute.lat){
        this.showZoom.lat = Number(show[0].attribute.lat);
        this.showZoom.lon = Number(show[0].attribute.lon);
        this.lat = this.showZoom.lat;
        this.lon = this.showZoom.lon;
        this.zoom = 140;
      }
    }
   
  }

}
